export enum ProgressEvent {
    COMPLETE = 'complete',
    STARTING = 'starting',
    MEASUREMENT = 'measurement',
    ERROR = 'error',
}
